import { gql } from '@apollo/client';

/* ── systematic plans & orders (Transactions) ───────────────── */

/**
 * NSE MF platform registrations for the signed-in account.
 * These are per-user (the resolver reads the caller from the token), so the
 * book-wide order blotter the design shows is only as wide as the caller's
 * own registrations until a book-scoped listing exists.
 */
export const MF_SIPS = gql`
  query MfSips($status: String) {
    mfXsips(status: $status) {
      id
      platformSipRegNo
      schemeCode
      schemeName
      installmentAmount
      frequency
      noOfInstallments
      sipStartDate
      sipEndDate
      xsipStatus
      installmentsCompleted
      consecutiveFailures
      stepUpAmount
      stepUpFrequency
      createdAt
    }
  }
`;

export const MF_SWPS = gql`
  query MfSwps($status: String) {
    mfSwps(status: $status) {
      id
      schemeCode
      schemeName
      withdrawalAmount
      frequency
      noOfInstallments
      swpStartDate
      swpEndDate
      swpStatus
      installmentsCompleted
      createdAt
    }
  }
`;

export const MF_STPS = gql`
  query MfStps($status: String) {
    mfStps(status: $status) {
      id
      route
      sourceSchemeCode
      sourceSchemeName
      targetSchemeCode
      targetSchemeName
      transferAmount
      frequency
      noOfInstallments
      stpStartDate
      stpStatus
      unifiedStatus
      attentionReason
      installmentsCompleted
      inTransitAmount
      createdAt
    }
  }
`;
